import FeaturesIntegrations from './FeaturesIntegrations'

export default FeaturesIntegrations
